import React from 'react';
import { Button, Table } from 'react-bootstrap';
import { Bert } from 'meteor/themeteorchef:bert';
import AdminUserSettingsModal from '../../components/AdminUserSettingsModal';
import handleErrorInClient from '../../../modules/handle-error-in-client';
import methodPromise from '../../../modules/method-promise-wrapper';
import PageHeader from '../../atoms/PageHeader';

class AdminUserSettings extends React.Component {
  state = { userSettings: [], showSettingsModal: false, currentSetting: null };

  componentDidMount() {
    this.fetchSettings();
  }

  fetchSettings = async () => {
    try {
      const userSettings = await methodPromise('admin.fetchUserSetting');
      this.setState({ userSettings });
    } catch (error) {
      handleErrorInClient(error);
    }
  };

  handleDeleteSetting = async settingId => {
    if (
      // FIXME: eliminar confirm
      // eslint-disable-next-line no-alert,no-restricted-globals
      confirm(
        "Are you sure? Before deleting this setting make sure that it's no longer in use in your application!"
      )
    ) {
      try {
        await methodPromise('admin.deleteUserSetting', settingId);
        Bert.alert('Setting deleted!', 'success');
        this.fetchSettings();
      } catch (error) {
        handleErrorInClient(error);
      }
    }
  };

  render() {
    const { userSettings, showSettingsModal, currentSetting } = this.state;
    return (
      <>
        <PageHeader>
          <h4>User Settings</h4>
          <Button
            variant="success"
            className="ml-auto"
            onClick={() => this.setState({ showSettingsModal: true })}
          >
            Add Setting
          </Button>
        </PageHeader>
        <Table responsive bordered>
          <thead>
            <tr>
              <th>Key</th>
              <th width="15%" />
              <th width="15%" />
            </tr>
          </thead>
          <tbody>
            {userSettings.map(setting => (
              <tr key={setting._id}>
                <td>{setting.key}</td>
                <td>
                  <Button
                    variant="light"
                    onClick={() =>
                      this.setState({ showSettingsModal: true, currentSetting: setting })
                    }
                    block
                  >
                    Edit
                  </Button>
                </td>
                <td>
                  <Button
                    variant="danger"
                    onClick={() => this.handleDeleteSetting(setting._id)}
                    block
                  >
                    Delete
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        <AdminUserSettingsModal
          show={showSettingsModal}
          onHide={() => {
            this.setState({ showSettingsModal: false, currentSetting: null }, () =>
              this.fetchSettings()
            );
          }}
          setting={currentSetting}
        />
      </>
    );
  }
}

AdminUserSettings.propTypes = {
  // prop: PropTypes.string.isRequired,
};

export default AdminUserSettings;
